import i18next from 'i18next'
import {Updater} from 'widgets-for-react'
import {UserData} from '../../subscription/subscriptionState'
import {
  buildValidator,
  isValidatorPassed,
  Validator,
  validatorBuilders,
  ValidatorResult,
  validatorResultBuilders,
} from '../../validator/validator'

export type Job = Partial<{ Title: string; Id: number }>
export const emptyJob: Job = {}

const jobValidator = buildValidator<Job>({
  Id: [
    (b) => b.ne(-1),
    validatorBuilders.number('Id', () =>
      i18next.t(`subscriptionValidators:Job`)
    ),
  ],
})

export type JobState = {
  input: Job
  validator: Validator<Job, Job>
  validatorResult: ValidatorResult
  isValid(): boolean
}

export const initialJobState = (userData?: UserData): JobState => {
  let initialJob = emptyJob
  if (userData && userData.Job) {
    initialJob.Id = userData?.Job?.Id
    initialJob.Id = userData?.Job?.Id
  }
  return {
    input: initialJob,
    validator: jobValidator.setValueToValidate(initialJob, initialJob),
    validatorResult: validatorResultBuilders.validating(''),
    isValid: function (this: JobState) {
      return isValidatorPassed(this.validatorResult)
    },
  }
}

export const jobStateUpdaters = {
  input:
    (u: Updater<JobState['input']>): Updater<JobState> =>
    (s) => {
      const newInput = u(s.input)
      return {
        ...s,
        input: newInput,
        validator: s.validator.setValueToValidate(newInput, newInput),
      }
    },
  validation:
    (u: Updater<JobState['validator']>): Updater<JobState> =>
    (s) => {
      const newValidator = u(s.validator)
      return {
        ...s,
        validator: newValidator,
        validatorResult: newValidator.evaluateResult(),
      }
    },
}
